import Home from './home'
import Goods from './goods'
import GoodsId from './goods/id'
import GoodsDec from './goods/dec'
import SearchGoods from './search'
import VIP from './vip'
import News from './news'
import NewsId from './news/id'
import Store from './store'
import Story from './story'
export const HomePage = Home
export const GoodsPage = Goods
export const GoodsIdPage = GoodsId
export const GoodsDecPage = GoodsDec
export const VipPage = VIP
export const NewsPage = News
export const NewsIdPage = NewsId
export const StoryPage = Story
export const StorePage = Store
export const SearchGoodsPage = SearchGoods
export default  {
    HomePage,
    GoodsPage,
    GoodsIdPage,
    GoodsDecPage,
    VipPage,
    NewsPage,
    NewsIdPage,
    StoryPage,
    StorePage,
    SearchGoodsPage
}

